import { createContext, useContext, useEffect, useState } from 'react'
import { getFromSessionStorage, saveInSessionStorage, removeFromSessionStorage } from '@lucan/base-ui'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material'
import { CHIAVI_SESSIONE } from 'configuration/ConfigurazioneSessione'
import { useShadowRoot } from 'ShadowContext'

const SESSIONE = 'sessione'

const SessioneContext = createContext()

function SessioneProvider(props) {
  const { children } = props

  const [mostraDialogScaduta, setMostraDialogScaduta] = useState(false)

  const [sessione, setSessione] = useState(
    () => getFromSessionStorage(SESSIONE) || {}
  )

  useEffect(() => {
    if (sessione) saveInSessionStorage(SESSIONE, sessione)
    else removeFromSessionStorage(SESSIONE)
  }, [sessione])

  function pulisciSessione() {
    setSessione(null)
  }

  function salvaInSessione(chiave, valore) {
    setSessione(sess => ({ ...sess, [chiave]: valore }))
  }

  function salvaInSessioneOggetto(nuoviDati) {
    setSessione(sess => ({ ...sess, ...nuoviDati }))
  }

  function rimuoviDaSessione(chiave) {
    // eslint-disable-next-line no-unused-vars
    setSessione(({ [chiave]: valore, ...sess }) => sess)
  }

  function mantieniInSessione(chiavi) {
    setSessione((sess) =>
      Object.fromEntries(
        Object.entries(sess).filter(([k]) => chiavi.includes(k))
      )
    )
  }

  function setSessioneScaduta() {
    setMostraDialogScaduta(true)
  }

  const contextValue = {
    ...sessione,
    esisteSessione: (sessione?.uuidSessione ?? '') != '',
    salvaInSessione,
    rimuoviDaSessione,
    pulisciSessione,
    setSessioneScaduta,
    salvaInSessioneOggetto,
    mantieniInSessione,
  }



  return (
    <SessioneContext.Provider value={contextValue}>
      {mostraDialogScaduta && <DialogSessioneScaduta
        open={mostraDialogScaduta}
        url={sessione?.[CHIAVI_SESSIONE.CHIAVE_ROTTA_HOME_SERVIZIO] ?? window.location.origin}
        onClose={() => setMostraDialogScaduta(false)}
      />}
      {children}
    </SessioneContext.Provider>
  )
}

function useSessione() {
  return useContext(SessioneContext)
}

// eslint-disable-next-line react-refresh/only-export-components
export { SessioneProvider, useSessione }



function DialogSessioneScaduta({ open, onClose, url }) {
  const shadowRoot = useShadowRoot()

  const handleClose = () => {
    onClose?.()
    location.replace(url) // redirect alla home
  }

  return (
    <Dialog open={open} onClose={handleClose} container={shadowRoot}>
      <DialogTitle>Sessione scaduta</DialogTitle>

      <DialogContent>
        La tua sessione è scaduta. Per favore accedi nuovamente.
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} autoFocus>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  )
}